

import { BidiModule } from '@angular/cdk/bidi';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MwcOutletModule } from 'mwc/core/outlet';
import { MwcIconModule } from 'mwc/icon';

import { MwcAlertComponent } from './alert.component';

@NgModule({
  declarations: [MwcAlertComponent],
  exports: [MwcAlertComponent],
  imports: [BidiModule, CommonModule, MwcIconModule, MwcOutletModule]
})
export class MwcAlertModule {}
